export const MOLLOY_STANDISH_1997 = Object.freeze({
  id: 'molloy-standish-1997',
  citation: 'Molloy DW, Standish TIM. A guide to the standardized Mini-Mental State Examination. Int Psychogeriatr. 1997;9 Suppl 1:87-94; discussion 143-150.',
  year: 1997,
  population: 'Publicação metodológica sobre administração e pontuação padronizadas do Mini-Mental State Examination.',
  sampleSize: 48,
  dataType: 'administration-standardization',
  results: {
    unspecifiedInstructionsIncreaseVariation: true,
    standardizationImprovesReliability: true,
    interraterVarianceReductionPct: 76,
    intraraterVarianceReductionPct: 86,
    iccBefore: 0.69,
    iccAfter: 0.90
  },
  limitations: [
    'É uma publicação metodológica; não define ponto de corte diagnóstico.',
    'Não deve ser usada para reconstruir ou reproduzir instruções licenciadas do instrumento.'
  ],
  primarySource: { kind: 'pmid', value: '9447431' },
  usedBy: ['/como-aplicar']
});
